export const ORDER_REQUEST_FILTER_PARAMETER_IDS = {
  requestType: 31,
  requestStatus: 34,
};
